import { useState } from "react";
import { Link } from "react-router-dom";
import { FileCheck2 } from "lucide-react";
import api, { apiError } from "../lib/api";
import { useAuth } from "../lib/auth";
import { useFlash } from "../lib/flash";

export default function LegalNotice() {
  const { store, refresh } = useAuth();
  const flash = useFlash();
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  if (done || !store?.legal_pending || store.staff || store.impersonated) return null;
  const accept = async () => {
    setBusy(true);
    try {
      const r = await api.post("/legal/accept");
      flash(r.data.flash);
      setDone(true);
      refresh();
    } catch (e) {
      flash(apiError(e.response?.data?.detail) || e.message, "error");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="card legal-notice" data-testid="legal-notice">
      <FileCheck2 size={22} />
      <div style={{ flex: 1 }}>
        <b>Vi har opdateret vilkår og databehandleraftale</b>
        <p className="muted" style={{ margin: "4px 0 0", fontSize: 14 }}>
          Læs <Link to="/vilkaar" target="_blank" data-testid="legal-notice-terms">vilkårene</Link>,{" "}
          <Link to="/databehandleraftale" target="_blank" data-testid="legal-notice-dpa">databehandleraftalen</Link> og{" "}
          <Link to="/privatliv" target="_blank" data-testid="legal-notice-privacy">privatlivspolitikken</Link>.
        </p>
      </div>
      <button className="btn primary small" onClick={accept} disabled={busy} data-testid="legal-notice-accept">
        Accepter
      </button>
    </div>
  );
}
